import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=3f27a256&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=3f27a256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27a256",
  null
  
)

export default component.exports